// @generated by protoc-gen-connect-es v1.1.4 with parameter "target=ts"
// @generated from file autokitteh/dispatcher/v1/svc.proto (package autokitteh.dispatcher.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DispatchRequest, DispatchResponse, RedispatchRequest, RedispatchResponse } from "./svc_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service autokitteh.dispatcher.v1.DispatcherService
 */
export const DispatcherService = {
  typeName: "autokitteh.dispatcher.v1.DispatcherService",
  methods: {
    /**
     * @generated from rpc autokitteh.dispatcher.v1.DispatcherService.Dispatch
     */
    dispatch: {
      name: "Dispatch",
      I: DispatchRequest,
      O: DispatchResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Does not creates the event, just resends an existing one.
     * This method also duplicates the event, and generates a new
     * event ID for it. The new event ID is returned in the response.
     *
     * @generated from rpc autokitteh.dispatcher.v1.DispatcherService.Redispatch
     */
    redispatch: {
      name: "Redispatch",
      I: RedispatchRequest,
      O: RedispatchResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

